module.exports = __webpack_public_path__ + "static/media/0322_Medium.41bdd099.jpg";